import { render } from "./FlexPage.vue?vue&type=template&id=f3230006&ts=true"
import script from "./FlexPage.vue?vue&type=script&lang=ts"
export * from "./FlexPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__